import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.074 4.77v10.406h10.407v-2.401h.8v3.202H1.274V3.969h3.203v.8H2.074z" fill="#fff" /><path fillRule="evenodd" clipRule="evenodd" d="M14.883 2.367H4.475v10.408h10.408V2.367zm-11.208-.8v12.008h12.008V1.567H3.675z" fill="#fff" /><path d="M8.479 9.573V5.57L11.68 7.57 8.479 9.573z" fill="#fff" /></svg>;